import { createContext } from 'preact/compat'

export const Loading = createContext(false)
export const Query = createContext(undefined)
export const SiteSettings = createContext({})